import { getCombinedAddressLines, getFormattedCustomerName } from 'client/components/customers/common/Helpers'
import { CompanyInterface } from 'client/Interfaces/CompanyInterface'
import * as React from 'react'

import countries from '../../../static/resources/countries.json'
import { AddressInterface } from '../../Interfaces/AddressInterface'
import { CustomerInterface } from '../../Interfaces/CustomerInterface'
import { DocumentType, DocumentTypes } from '../../Interfaces/Draft/DraftInterface'
import { tsxl } from '../../Other/Translation'
import Button, { ButtonType } from '../common/Button/Button'

export interface CustomerAddressPropsInterface {
  customer: CustomerInterface
  company: CompanyInterface
  documentType?: DocumentType
  openCustomerModal: () => void
}

// Check if address is valid. Also check if address is empty
export const hasAddress = (address: AddressInterface): boolean => {
  const requiredFields = ['streetAddress1', 'pobox', 'city']
  const hasAddress = requiredFields.some((field) => {
    if (address[field]) {
      return true
    }
    return false
  })
  return hasAddress
}

const hasShippingAddress = (shippingAddress: AddressInterface, documentType: DocumentType): boolean => {
  return (
    [DocumentTypes.DELIVERYNOTE, DocumentTypes.DELIVERYNOTEDRAFT].includes(documentType) &&
    shippingAddress &&
    Object.values(shippingAddress).some((x) => x !== null && x !== '')
  )
}

const isCountryVisible = (customer: CustomerInterface, company: CompanyInterface): boolean => {
  const { shippingAddress, address } = customer
  if (shippingAddress?.country) {
    return (
      shippingAddress?.country !== address?.country ||
      shippingAddress !== company?.country ||
      address?.country !== company?.country
    )
  }
  return address?.country !== company?.country
}

export class CustomerAddress extends React.Component<CustomerAddressPropsInterface, any> {
  public render(): JSX.Element {
    const { customer, documentType, company } = this.props
    const isCreditNote = documentType === DocumentTypes.CREDITNOTE
    if (!customer) {
      return null
    }
    let addressTooltip = null
    const editCustomerButton = (
      <Button
        automation="edit-customer-button"
        label={tsxl('Edit')}
        type={ButtonType.link}
        action={() => {
          this.props.openCustomerModal()
        }}
      />
    )
    if (!hasAddress(customer.address)) {
      addressTooltip = (
        <div className="CustomerNoAddress" data-automation="customer-noaddress">
          {tsxl('address.noAddress')}
        </div>
      )
    }
    const displayName = getFormattedCustomerName(customer, false)
    return (
      <div className="CustomerAddress" data-automation="customer-address-block">
        <div data-automation="customer-name" className="customerName">
          {displayName}
        </div>
        <div>{tsxl('Address')}:</div>
        <div className="customerStreetAddress" data-automation="customer-street-address">
          {getCombinedAddressLines(customer.address)}
        </div>
        <div className="customerZipCity" data-automation="customer-zip-city">
          {customer.address?.pobox} {customer.address?.city}
        </div>
        {isCountryVisible(customer, company) && (
          <div className="customerCountry" data-automation="customer-country">
            {countries[customer.address?.country]}
          </div>
        )}

        {addressTooltip}
        {hasShippingAddress(customer?.shippingAddress, documentType) && (
          <div className={'ShippingAddress'}>
            <div>{tsxl('ShippingAddress')}:</div>
            <div data-automation="customer-street-address">{getCombinedAddressLines(customer.shippingAddress)}</div>
            <div data-automation="customer-zip-city">
              {customer?.shippingAddress?.pobox} {customer?.shippingAddress?.city}
            </div>
            {isCountryVisible(customer, company) && (
              <div data-automation="customer-zip-city">{countries[customer?.shippingAddress?.country]}</div>
            )}
          </div>
        )}
        {!isCreditNote && editCustomerButton}
      </div>
    )
  }
}
